export function qString() {
    return new URLSearchParams(window.location.search);
}
